import React from 'react';
import RenderPDFPreview from '../global/RenderPDFPreview';
import { DEFAULT_PDF_ZOOM } from '../global/constants';
import './Modal.css';
import withShipment from '../../withShipment';
import { FILE_PREVIEW } from '../global/Server/endpoints';
import { apiRequest } from '../../redux/actions/api';

class FilePreviewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attemptFailed: false,
      pdfData: null,
      loading: false,
    };
  }

  componentDidMount() {
    const { file } = this.props;
    if (file?.path && file?.type === 'application/pdf') {
      this.fetchPdfPreview(file.path);
    }
  }

  fetchPdfPreview = (filePath) => {
    this.setState({ loading: true });
    // Routed through the generic api saga (Redux Saga + AuthUtil) — no
    // direct axios. Errors are kept silent so the modal handles them
    // locally instead of pushing to the global ErrorFeedbackBar.
    this.props.apiRequest({
      key: `filePreview/${filePath}`,
      endpoint: FILE_PREVIEW.PREVIEW_PDF,
      data: { path: filePath },
      silent: true,
      onSuccess: (payload) => {
        if (payload?.success && Array.isArray(payload.pdfByte)) {
          this.setState({
            pdfData: new Uint8Array(payload.pdfByte),
            loading: false,
          });
        } else {
          this.setState({ attemptFailed: true, loading: false });
        }
      },
      onError: () => {
        this.setState({ attemptFailed: true, loading: false });
      },
    });
  };

  renderDownloadUI = (fileName, fileUrl) => {
    return (
      <div className="unsupported-file-container">
        <div className="unsupported-icon">
          <span role="img" aria-label="document icon">
            📄
          </span>
        </div>
        <h3 className="unsupported-title">Preview Not Supported</h3>
        <p className="unsupported-text">
          We can't display{' '}
          <span className="file-highlight">{fileName || 'this file'}</span>{' '}
          directly in your browser. Only images and PDFs can be viewed here.
        </p>
      </div>
    );
  };

  render() {
    const { file, handlePdfLoadSuccess, handlePdfLoadError } = this.props;
    const { pdfData, attemptFailed, loading } = this.state;

    if (!file) return null;

    const isImage = file.type?.startsWith('image');
    const isPDF = file.type === 'application/pdf';
    const isUnsupported = !isImage && !isPDF;

    return (
      <div className="preview-wrapper">
        {/* 1. Loading State */}
        {loading && (
          <div className="preview-loader">
            <div className="spinner"></div>
            <p>Loading preview...</p>
          </div>
        )}

        {/* 2. Image Preview */}
        {isImage && !attemptFailed && (
          <div className="image-preview-container">
            <img
              alt="preview"
              src={file.url}
              className="image-preview"
              onLoad={() => this.setState({ loading: false })}
              style={{ display: loading ? 'none' : 'block' }}
              onError={() =>
                this.setState({ attemptFailed: true, loading: false })
              }
            />
          </div>
        )}

        {/* 3. PDF Preview */}
         {file.type === 'application/pdf' && pdfData && !attemptFailed && (
              <RenderPDFPreview
                  data={{ pdfData }}
                  creating={true}
                  handlePdfLoadSuccess={handlePdfLoadSuccess}
                  handlePdfLoadError={handlePdfLoadError}
                  scale={DEFAULT_PDF_ZOOM}
              />
          )}

        {/* 4. Unsupported or Failed State */}
        {(isUnsupported || attemptFailed) &&
          !loading &&
          this.renderDownloadUI(file.name, file.url)}
      </div>
    );
  }
}

export default withShipment(
  {
    actionCreators: { apiRequest },
  },
  FilePreviewer,
);
